import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreateMatchProfile } from "~pages/MatchProfiles/types/upsertMatchProfile.ts";
import type { FixtureProfileResponse } from "~types/fixtureProfile.ts";

export const useCreateMatchProfile = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<FixtureProfileResponse | undefined, Error, CreateMatchProfile>({
    mutationFn: async (data) => {
      return await request<FixtureProfileResponse>(`${sport}/o/${organizationId}/fixtureProfiles`, {
        method: "POST",
        body: data,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["matchProfiles", sport, organizationId] });
    },
  });
};
